export default "__VITE_ASSET__CgFoPXlq__"